import { apiPOST } from './api';

export const sendContactRequest = ({ name, email, message, zipCode }) =>
  apiPOST('/contact_us', {
    message: message,
    zip_code: zipCode,
    name: name,
    email: email
  });
